import { privateDependencyFailure } from "./private-cause.ts";
import { Redacted } from "effect";
import { messageHttpFailure } from "./http-message.ts";
import { Match, Schema } from "effect";

export const RecordingRequestError = /* @__PURE__ */ (() => {
  class RecordingRequestError extends Schema.TaggedError<RecordingRequestError>()("RecordingRequestError", {
    message: Schema.String, status: Schema.Literals([400, 403, 404, 405, 409, 410, 413, 416]),
    allow: Schema.optionalKey(Schema.String)
  }) {}
  return RecordingRequestError;
})();
export type RecordingRequestError = InstanceType<typeof RecordingRequestError>;
export const RecordingStorageError = /* @__PURE__ */ (() => class RecordingStorageError extends messageHttpFailure<RecordingStorageError>()("RecordingStorageError", 500) {})();
export type RecordingStorageError = InstanceType<typeof RecordingStorageError>;
export type RecordingFailure = RecordingRequestError | RecordingStorageError | RecordingStoreError;

export const recordingInvalid = (message: string) => new RecordingRequestError({ message, status: 400 });
export const recordingMissing = (message = "Unknown flow recording.") => new RecordingRequestError({ message, status: 404 });
export const recordingUnavailable = () => new RecordingStorageError({ message: "Flow recording storage is unavailable." });
export const recordingMethodNotAllowed = (allow: string) => new RecordingRequestError({ message: "Method not allowed.", status: 405, allow });
export const recordingPinned = () => new RecordingRequestError({ message: "The flow recording is retained by an active pin.", status: 409 });
export const recordingExpired = () => new RecordingRequestError({ message: "The flow recording has expired.", status: 410 });
export const recordingSegmentTooLarge = () => new RecordingRequestError({ message: "segment body exceeds the upload limit.", status: 413 });
export const recordingRangeInvalid = () => new RecordingRequestError({ message: "Invalid Range header.", status: 416 });
export const recordingRefused = (refused: string) => Match.value(refused).pipe(
  Match.when("unknown-recording", () => recordingMissing()),
  Match.when("invalid-token", () => new RecordingRequestError({ status: 403, message: "A valid x-flow-recording-token header is required." })),
  Match.when("terminal-state", () => new RecordingRequestError({ status: 409, message: "The flow recording is already finalized." })),
  Match.when("conflicting-segment", () => new RecordingRequestError({ status: 409, message: "A different segment is already registered at this sequence." })),
  Match.orElse(value => recordingInvalid(`Invalid flow recording request: ${value}.`))
);

export const RecordingStoreError = /* @__PURE__ */ (() => {
  class RecordingStoreError extends privateDependencyFailure<RecordingStoreError>()('RecordingStoreError', 'recording storage') {}
  return RecordingStoreError;
})();
export type RecordingStoreError = InstanceType<typeof RecordingStoreError>;
export const recordingStoreFailure = (cause: unknown) => new RecordingStoreError({ cause: Redacted.make(cause) });
